<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">Add to Punch List</span>
  </div>
  <button mat-button [tabindex]="-1" class="close-button-container" (click)="cancel()" disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
    <div class="content-title">Unchecked items:</div>
  <div class="loading-container" *ngIf="loading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="inputs-block" *ngIf="!loading">
    <div class="scrollable-items" #scrollableItems>
      <div class="input-block" *ngFor="let cabinet of cabinets; let i = index; trackBy: trackByIndex">
        <div class="item-row">
          <div class="email-input-text">
            <textarea
              [(ngModel)]="cabinet.cabinetName"
              placeholder="Cabinet name"
              class="arrow-input cabinet-textarea"
              [ngModelOptions]="{standalone: true}">
            </textarea>
          </div>
          <div class="remove-item-btn" (click)="removeItem(i)" *ngIf="cabinets.length > 1">
            <mat-icon>delete</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="save-btn-block">
    <button mat-button class="cancel-btn" (click)="cancel()">
        <mat-icon>clear</mat-icon>
        <div class="button-title">Cancel</div>
    </button>
    <button mat-button class="add-item-btn" (click)="addNewItem()">
      <mat-icon>add</mat-icon>
      <div class="button-title">Add Item</div>
    </button>
    <button mat-button class="save-btn" (click)="save()"
          [disabled]="saving || cabinets.length === 0"
          [ngClass]="{'disabled-button': saving || cabinets.length === 0}">
      <mat-icon>done</mat-icon>
    <lib-mini-progress-spinner *ngIf="saving"></lib-mini-progress-spinner>
      <div class="button-title" *ngIf="!saving">Save</div>
    </button>
  </div>
</div>
